export const BARRIOS = [
  'Barreda', 'Barrio Covadonga', 'Campuzano', 'Centro', 'Duález', 'Ganzo',
  'La Inmobiliaria', 'La Montaña', 'Las Traídas', 'Nueva Ciudad',
  'Sierrapando', 'Tanos', 'Torres', 'Viérnoles', 'Zapatón',
];

// BARRIOS holds two kinds of place: barrios of the town of Torrelavega and the nine pueblos of the
// municipality (its INE population centres besides Torrelavega itself, the same localities as
// services/farmacias.LOCALIDADES). A vecina of Campuzano pointed out it is a pueblo, not a barrio
// (feedback, 23 Oct 2026): the pickers show the two groups apart. The stored field is still
// «barrio», with the same values, so nothing saved changes.
export const BARRIOS_CIUDAD = ['Barrio Covadonga', 'Centro', 'La Inmobiliaria', 'Las Traídas', 'Nueva Ciudad', 'Zapatón'];
export const PUEBLOS = ['Barreda', 'Campuzano', 'Duález', 'Ganzo', 'La Montaña', 'Sierrapando', 'Tanos', 'Torres', 'Viérnoles'];
export const ZONA_GRUPOS = [
  { label: 'Barrios de Torrelavega', items: BARRIOS_CIUDAD },
  { label: 'Pueblos', items: PUEBLOS },
];

// Centre of each barrio, the same points backend/routes/geocode.py uses (BARRIO_CENTERS). Inicio's
// «Tu barrio» falls back to one of these when the reader's location is unavailable or denied.
export const BARRIO_CENTERS = {
  'Centro': [43.3510, -4.0512], 'La Inmobiliaria': [43.3542, -4.0456], 'Nueva Ciudad': [43.3412, -4.0528],
  'Barrio Covadonga': [43.3462, -4.0622], 'La Montaña': [43.3233, -4.0166], 'Zapatón': [43.3470, -4.0500],
  'Campuzano': [43.3397, -4.0582], 'Tanos': [43.3325, -4.0438], 'Torres': [43.3532, -4.0684],
  'Sierrapando': [43.3439, -4.0329], 'Barreda': [43.3687, -4.0425], 'Viérnoles': [43.3210, -4.0537],
  'Ganzo': [43.3594, -4.0674], 'Duález': [43.3622, -4.0594], 'Las Traídas': [43.3555, -4.0394],
};
